import React from 'react';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { formatDate, formatTime } from '../../Utils';
import { DebtorClaimEvent, ClaimEventType } from '../../../api/client';
import currencyFormatter from 'currency-formatter';
import DebtorClaimEventDetailsTooltip from '../containers/DebtorClaimEventDetailsTooltip';
import { colors } from './../../../colors';

interface Props {
  event: DebtorClaimEvent;
  claimSystem: String;
  debtorId: String;
}

export default function DebtorClaimEventComponent(props: Props) {
  return (
    <React.Fragment>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px',
      }}>
        <Tooltip title={formatTime(props.event.eventDate)} placement="left-start">
          <Typography sx={{
            marginRight: '30px',
          }}>
            {formatDate(props.event.eventDate)}
          </Typography>
        </Tooltip>
        <Box sx={{ minWidth: '40px' }}>
          <DebtorClaimEventDetailsTooltip debtorId={props.debtorId!} claimSystem={props.claimSystem} referenceNumber={props.event.referenceNumber} eventId={props.event.eventId!} eventType={props.event.eventType!} eventName={props.event.eventName} eventTooltip={props.event.tooltip!} documentId={props.event.documentId} filename={props.event.documentFilename} documentStage={props.event.documentStage} />
        </Box>
        <Box sx={{
          flexGrow: 2,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
          <Typography>
            {props.event.description}
          </Typography>
        </Box>
        <Typography sx={{
          fontWeight: 'bold',
          marginLeft: '10px',
          color: props.event.eventType ? (props.event.eventType === ClaimEventType.Payment || props.event.eventType === ClaimEventType.DirectPaymentSent) ? colors.secondary.bamboo : colors.secondary.candy : colors.black
        }}>
          {props.event.amount ? currencyFormatter.format(props.event.amount, { code: 'NOK' }) : ''}
        </Typography>
      </Box>
      <Divider />
    </React.Fragment>
  )
};
